import React, { Component, createRef } from 'react'
import PropTypes from 'prop-types'
import styles from './Inputfield.module.css'
import styleNames from '../../utils/styleNames'
import classNames from 'classnames'

export class Inputfield extends Component {
  constructor(props) {
    super(props)
    this.input = createRef()
    this.state = {
      updateTimer: null
    }
  }

  focus () {
    this.input.current.focus()
  }

  render () {
    const { autoFocus, errorMessage, label, inputClasses, onBlur, onChange, offset, onFocus, onKeyPress, placeholder, type, value, maxLength, marginRight, size, small, grow, min, max } = this.props
    const inputFieldContainerClasses = classNames('inputFieldContainer', {
      grow: grow,
      small: small,
      'margin-right': marginRight,
      number: type === 'number'
    })
    const inputFieldClasses = inputClasses ? 'inputField ' + inputClasses : 'inputField'
    return (      
      <div
        style={{
          left: offset ? offset : 0
        }}
        className={styleNames(styles, inputFieldContainerClasses)}>
        {label && <label className={styles.label}>{label}</label>}
        <div style={{ position: 'relative' }}>
          <div className={styleNames(styles, errorMessage === '' ? 'no-error' : 'has-error' + ' error')}>
            <div />
            <span>{errorMessage}</span>
          </div>        
          <input
            autoFocus={autoFocus}
            max={max}
            maxLength={maxLength}
            min={min}
            onBlur={onBlur}
            onChange={onChange}
            onFocus={onFocus}
            onKeyPress={onKeyPress}
            placeholder={placeholder}
            ref={this.input}
            size={size}
            className={styleNames(styles, inputFieldClasses)}
            type={type}
            value={value} />
            {this.props.children}
          </div>
      </div>
    )
  }
}

Inputfield.propTypes = {
  autoFocus: PropTypes.bool,
  children: PropTypes.node,
  errorMessage: PropTypes.string,
  grow: PropTypes.bool,
  inputClasses: PropTypes.string,
  label: PropTypes.string,
  marginRight: PropTypes.bool,
  max: PropTypes.string,
  maxLength: PropTypes.number,
  min: PropTypes.string,
  offset: PropTypes.number,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyPress: PropTypes.func,
  placeholder: PropTypes.string,
  size: PropTypes.number,
  small: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.string
}

Inputfield.defaultProps = {
  type: 'text',
  errorMessage: ''
}

export default Inputfield
